import { ensureAnimFromAtlas } from '../../../atlas-anims';

export type TigerWorldState = 'crossed' | 'angry';

const WORLD_TEXTURES: Record<TigerWorldState, string> = {
  crossed: 'tiger-crossed',
  angry: 'tiger-angry',
};

const WORLD_ANIMS: Record<TigerWorldState, string> = {
  crossed: 'tiger-crossed-idle',
  angry: 'tiger-angry-idle',
};

export function registerTigerAnims(scene: Phaser.Scene) {
  ensureAnimFromAtlas(scene, WORLD_ANIMS.crossed, WORLD_TEXTURES.crossed, 30);
  ensureAnimFromAtlas(scene, WORLD_ANIMS.angry, WORLD_TEXTURES.angry, 30);
}

export function playTigerAnim(sprite: Phaser.GameObjects.Sprite, state: TigerWorldState) {
  const textureKey = WORLD_TEXTURES[state];
  const animKey = WORLD_ANIMS[state];
  if (!sprite.scene.textures.exists(textureKey)) return;
  if (sprite.texture.key !== textureKey) sprite.setTexture(textureKey);
  if (!sprite.scene.anims.exists(animKey)) return;
  if (sprite.anims.currentAnim?.key !== animKey || !sprite.anims.isPlaying) {
    sprite.play(animKey, true);
  }
}
